const routes = [
  {
    path: '/',
    name: '/',
    redirect: '/home'
  },
  {
    path: '*',
    name: '*',
    redirect: '/404'
  },
  {
    name: 'rjAuthLoginPage',
    path: '/rjAuthLoginPage'
  },
  {
    path: '/404',
    name: '404',
    component: () => import('@/components/page404')
  },
  {
    path: '/401',
    name: '401',
    component: () => import('@/components/page401')
  },
  {
    path: '/maintenancePage',
    name: 'maintenancePage',
    component: () => import('@/components/maintenancePage')
  },
  // 渠道签约
  {
    path: '/qdSignContract',
    name: 'qdSignContract',
    component: () => import('@/components/qdSignContract')
  },
  // 渠道签约详情页
  {
    path: '/qdSignContractDetail',
    name: 'qdSignContractDetail',
    component: () => import('@/components/qdSignContractDetail')
  },
  // 主页
  {
    path: '/home',
    name: 'home',
    component: () => import('@/views/home/home.vue')
  },
  // 年度规划列表
  {
    path: '/annualMarketingPlan',
    name: 'annualMarketingPlan',
    component: () => import('@/views/annualMarketingPlan/index.vue'),
    meta: {
      name: 'home.annualMarketingPlan'
    }
  },
  // 年度规划申请
  {
    path: '/annualPlanApplication',
    name: 'annualPlanApplication',
    component: () => import('@/views/annualMarketingPlan/annualPlanApplication/index.vue'),
    meta: {
      name: '年度规划申请',
      level: 1,
      active: '/annualMarketingPlan'
    }
  },
  // 年度规划详情
  {
    path: '/annualPlanDetails',
    name: 'annualPlanDetails',
    component: () => import('@/views/annualMarketingPlan/annualPlanApplication/index.vue'),
    meta: {
      name: '年度规划详情',
      level: 1,
      active: '/annualMarketingPlan'
    }
  },
  // 季度填报申请
  {
    path: '/quarterlyFilingApplication',
    name: 'quarterlyFilingApplication',
    component: () => import('@/views/annualMarketingPlan/quarterlyFilingApplication/index.vue'),
    meta: {
      name: '季度填报申请',
      level: 1,
      active: '/annualMarketingPlan'
    }
  },
  // 季度填报详情
  {
    path: '/quarterlyFilingDetails',
    name: 'quarterlyFilingDetails',
    component: () => import('@/views/annualMarketingPlan/quarterlyFilingApplication/index.vue'),
    meta: {
      name: '季度填报详情',
      level: 1,
      active: '/annualMarketingPlan'
    }
  },
  // 快捷申请
  {
    path: '/quickApplicationForm',
    name: 'quickApplicationForm',
    component: () => import('@/views/newApplicationForm/quickApplication.vue'),
    meta: {
      name: 'home.qa'
    }
  },
  // 渠道申请
  {
    path: '/qdApplication',
    name: 'qdApplication',
    component: () => import('@/views/newApplicationForm/qdApplication.vue'),
    meta: {
      name: 'home.ca'
    }
  },
  // 渠道申请 - 编辑
  {
    path: '/editQdApplication',
    name: 'editQdApplication',
    component: () => import('@/views/newApplicationForm/qdApplication.vue'),
    meta: {
      name: 'btn.Edit',
      level: 2
    }
  },
  // 报备申请
  {
    path: '/reportApplication',
    name: 'reportApplication',
    component: () => import('@/views/newApplicationForm/reportApplication.vue'),
    meta: {
      name: 'home.aff'
    }
  },
  // 报备申请 - 编辑
  {
    path: '/editReportApplication',
    name: 'editReportApplication',
    component: () => import('@/views/newApplicationForm/reportApplication.vue'),
    meta: {
      name: 'btn.Edit',
      level: 2
    }
  },
  // 报备转申请页
  {
    path: '/transferApplication',
    name: 'transferApplication',
    component: () => import('@/views/newApplicationForm/reportApplication.vue'),
    meta: {
      name: 'btn.TransferApp',
      level: 2
    }
  },
   // 行业报备申请
  {
    path: '/industryReportApplication',
    name: 'industryReportApplication',
    component: () => import('@/views/newApplicationForm/industryReportApplication.vue'),
    meta: {
      name: 'home.aff'
    }
  },
   // 行业报备申请 - 编辑
  {
    path: '/editIndustryReportApplication',
    name: 'editIndustryReportApplication',
    component: () => import('@/views/newApplicationForm/industryReportApplication.vue'),
    meta: {
      name: 'btn.Edit',
      level: 2
    }
  },
   // 行业报备转申请页
  {
    path: '/industryReportTransferApplication',
    name: 'industryReportTransferApplication',
    component: () => import('@/views/newApplicationForm/industryReportApplication.vue'),
    meta: {
      name: 'btn.TransferApp',
      level: 2
    }
  },
   // 区域报备申请
  {
    path: '/editRegionReportApplication',
    name: 'editRegionReportApplication',
    component: () => import('@/views/newApplicationForm/regionReportApplication.vue'),
    meta: {
      name: 'home.aff'
    }
  },
   // 区域报备转申请页
  {
    path: '/regionReportTransferApplication',
    name: 'regionReportTransferApplication',
    component: () => import('@/views/newApplicationForm/regionReportApplication.vue'),
    meta: {
      name: 'home.aff'
    }
  },
   // 区域报备申请
  {
    path: '/regionReportApplication',
    name: 'regionReportApplication',
    component: () => import('@/views/newApplicationForm/regionReportApplication.vue'),
    meta: {
      name: 'home.aff'
    }
  },
  // 活动申请编辑
  {
    path: '/editApplication',
    name: 'editApplication',
    component: () => import('@/views/newApplicationForm/activityApplication.vue'),
    meta: {
      name: 'btn.Edit',
      level: 2
    }
  },
  // 活动申请
  {
    path: '/activityApplication',
    name: 'activityApplication',
    component: () => import('@/views/newApplicationForm/activityApplication.vue'),
    meta: {
      name: 'home.ea'
    }
  },
  // 报备转活动申请
  {
    path: '/activityTransferApplication',
    name: 'activityTransferApplication',
    component: () => import('@/views/newApplicationForm/activityApplication.vue'),
    meta: {
      name: 'home.ea'
    }
  },
  // 报备转快捷申请
  {
    path: '/quickTransferApplication',
    name: 'quickTransferApplication',
    component: () => import('@/views/newApplicationForm/quickApplication.vue'),
    meta: {
      name: 'btn.Edit',
      level: 2
    }
  },
  // 快捷申请
  {
    path: '/editQuickApplication',
    name: 'editQuickApplication',
    component: () => import('@/views/newApplicationForm/quickApplication.vue'),
    meta: {
      name: 'btn.Edit',
      level: 2
    }
  },
  // 报备列表
  {
    path: '/reportList',
    name: 'reportList',
    component: () => import('@/views/activitieList/reportList.vue'),
    meta: {
      name: 'home.RL',
      active: '/reportList'
    }
  },
  // 行业报备列表
  {
    path: '/industryReportList',
    name: 'industryReportList',
    component: () => import('@/views/activitieList/industryReportList'),
    meta: {
      name: 'home.iL',
      active: '/industryReportList'
    }
  },
  //  行业报备申请详情
  {
    path: '/industryReportDetails',
    name: 'industryReportDetails',
    component: () => import('@/views/activitieList/industryReportDetails.vue'),
    meta: {
      name: 'home.iD',
      level: 1
    }
  },
  //  区域报备列表
  {
    path: '/regionReportList',
    name: 'regionReportList',
    component: () => import('@/views/activitieList/regionReportList.vue'),
    meta: {
      name: 'home.rrL',
      active: '/regionReportList'
    }
  },
   // 区域报备申请详情
  {
    path: '/regionReportDetails',
    name: 'regionReportDetails',
    component: () => import('@/views/activitieList/regionReportDetails.vue'),
    meta: {
      name: 'home.rrD',
      level: 1
    }
  },
  //  行业总部活动汇总表
  {
    path: '/industryActivitySummary',
    name: 'industryActivitySummary',
    component: () => import('@/views/activitieList/industryActivitySummary'),
    meta: {
      name: 'home.hyzb'
    }
  },
   // 行业模板活动汇总表
  {
    path: '/industryTemplateActivitySummary',
    name: 'industryTemplateActivitySummary',
    component: () => import('@/views/activitieList/industryTemplateActivitySummary'),
    meta: {
      name: 'home.hymb'
    }
  },
  // 报备申请详情
  {
    path: '/reportDetails',
    name: 'reportDetails',
    component: () => import('@/views/activitieList/reportDetails.vue'),
    meta: {
      name: 'home.RD',
      level: 1
    }
  },
  // 活动列表
  {
    path: '/activityQuery',
    name: 'activityQuery',
    component: () => import('@/views/activitieList/activityQuery.vue'),
    meta: {
      name: 'home.EL',
      active: '/activityQuery'
    }
  },
  // 活动详情
  {
    path: '/activityDetails',
    name: 'activityDetails',
    component: () => import('@/views/activitieList/activityDetails.vue'),
    meta: {
      name: 'home.ed',
      level: 1
    }
  },
  {
    path: '/drafts',
    name: 'drafts',
    component: () => import('@/views/activitieList/drafts.vue'),
    meta: {
      active: '/drafts',
      name: 'home.db'
    }
  },
  {
    path: '/addCostDetails',
    name: 'addCostDetails',
    component: () => import('@/views/activitieList/component/activityDetails/activistyCostAttribution/addCostDetails.vue'),
    meta: {
      name: 'home.AE',
      level: 2
    }
  },
  {
    path: '/reportAddCostDetails',
    name: 'reportAddCostDetails',
    component: () => import('@/views/activitieList/component/activityDetails/activistyCostAttribution/reportAddCostDetails.vue'),
    meta: {
      name: 'home.RAE',
      level: 2
    }
  },
  // 审批中心
  {
    path: '/pendingApproval',
    name: 'pendingApproval',
    component: () => import('@/views/approvalCenter/pendingApproval.vue'),
    meta: {
      name: 'home.pa',
      active: '/pendingApproval'
    }
  },
  {
    path: '/alreadyApproved',
    name: 'alreadyApproved',
    component: () => import('@/views/approvalCenter/alreadyApproved.vue'),
    meta: {
      name: 'home.Approved',
      active: '/alreadyApproved'
    }
  },
  // 帮助文档
  {
    path: '/helpDocumentation',
    name: 'helpDocumentation',
    component: () => import('@/views/helpDocumentation/helpDocumentation.vue'),
    meta: {
      name: 'home.hwd'
    }
  },
  // 后台管理
  {
    path: '/accountManagement',
    name: 'accountManagement',
    component: () => import('@/views/backStageManagement/accountManagement.vue')
  },
  {
    path: '/activityDataExport',
    name: 'activityDataExport',
    component: () => import('@/views/backStageManagement/activityDataExport.vue')
  },
  {
    path: '/budgetPerformance',
    name: 'budgetPerformance',
    component: () => import('@/views/backStageManagement/budgetPerformance.vue'),
    meta: {
      name: 'home.BP'
    }
  },
  {
    path: '/budgetUsageDetails',
    name: 'budgetUsageDetails',
    component: () => import('@/views/backStageManagement/children/budgetPerformance/usageDetails.vue'),
    meta: {
      name: 'home.DoB',
      active: '/budgetPerformance',
      level: 1
    }
  },
  {
    path: '/budgetPerformancePermission',
    name: 'budgetPerformancePermission',
    component: () => import('@/views/backStageManagement/budgetPerformancePermission.vue'),
    meta: {
      name: 'home.BPP'
    }
  },
  {
    path: '/expensesJurManagement',
    name: 'expensesJurManagement',
    component: () => import('@/views/backStageManagement/expensesJurManagement.vue')
  },
  {
    path: '/approvalManagement',
    name: 'approvalManagement',
    component: () => import('@/views/backStageManagement/approvalManagement.vue')
  },
  {
    path: '/transferOrder',
    name: 'transferOrder',
    component: () => import('@/views/backStageManagement/transferOrder.vue'),
    meta: {
      name: 'home.single'
    }
  },
  {
    path: '/channelAccountManagement',
    name: 'channelAccountManagement',
    component: () => import('@/views/backStageManagement/channelAccountManagement.vue')
  },
  {
    path: '/templateActivityManagement',
    name: 'templateActivityManagement',
    component: () => import('@/views/backStageManagement/templateActivityManagement.vue')
  },
  {
    path: '/hqActivityManagement',
    name: 'hqActivityManagement',
    component: () => import('@/views/backStageManagement/hqActivityManagement.vue')
  },
  {
    path: '/businessUnitManagement',
    name: 'businessUnitManagement',
    component: () => import('@/views/backStageManagement/businessUnitManagement.vue')
  },
  {
    path: '/roleManagement',
    name: 'roleManagement',
    component: () => import('@/views/backStageManagement/roleManagement.vue')
  },
  {
    path: '/authorityManagement',
    name: 'authorityManagement',
    component: () => import('@/views/backStageManagement/authorityManagement.vue')
  },
  {
    path: '/cluePoolManagement',
    name: 'cluePoolManagement',
    component: () => import('@/views/backStageManagement/cluePoolManagement.vue'),
    meta: {
      name: '线索池管理'
    }
  },
  {
    path: '/privateSeaPoolManagement',
    name: 'privateSeaPoolManagement',
    component: () => import('@/views/backStageManagement/privateSeaPoolManagement.vue'),
    meta: {
      name: '私海池管理'
    }
  },
  {
    path: '/clueCirculationRecord',
    name: 'clueCirculationRecord',
    component: () => import('@/views/backStageManagement/clueCirculationRecord.vue'),
    meta: {
      name: '线索流转记录'
    }
  },
  {
    path: '/clueStaffCircConfigure',
    name: 'clueStaffCircConfigure',
    component: () => import('@/views/backStageManagement/clueStaffCircConfigure.vue')
  },
  {
    path: '/industryManagement',
    name: 'industryManagement',
    component: () => import('@/views/backStageManagement/industryManagement.vue')
  },
  {
    path: '/activityBase',
    name: 'activityBase',
    component: () => import('@/views/backStageManagement/activityBase.vue')
  },
  {
    path: '/documentViewPermission',
    name: 'documentViewPermission',
    component: () => import('@/views/backStageManagement/documentViewPermission.vue')
  },
  {
    path: '/ruleConfiguration',
    name: 'ruleConfiguration',
    component: () => import('@/views/newApplicationForm/ruleConfiguration.vue'),
    meta: {
      name: '活动分层配置'
    }
  },
  // 线索池
  {
    path: '/cluePoolList',
    name: 'cluePoolList',
    component: () => import('@/views/cluePool/cluePoolList.vue'),
    meta: {
      name: 'home.LocP'
    }
  },
  {
    path: '/clueDetails',
    name: 'clueDetails',
    component: () => import('@/views/cluePool/children/clueDetails.vue'),
    meta: {
      name: 'home.DoC',
      level: 1
    }
  },
  // 私海池
  {
    path: '/waitingProcessing',
    name: 'waitingProcessing',
    component: () => import('@/views/privateSeaPool/waitingProcessing.vue'),
    meta: {
      name: 'home.Pending'
    }
  },
  {
    path: '/selfFollow',
    name: 'selfFollow',
    component: () => import('@/views/privateSeaPool/selfFollow.vue'),
    meta: {
      name: 'home.Fuby'
    }
  },
  {
    path: '/completedProcessing',
    name: 'completedProcessing',
    component: () => import('@/views/privateSeaPool/completedProcessing.vue'),
    meta: {
      name: 'home.Processed'
    }
  },
  {
    path: '/clueSuspend',
    name: 'clueSuspend',
    component: () => import('@/views/privateSeaPool/clueSuspend.vue'),
    meta: {
      name: 'home.PutUp'
    }
  }
];

export default routes;
